const etc = {
    title: 'Haptics',
    about: '시범콘텐츠 중 ‘미라의 발굴’에 활용된 기술로 유니티에서 CHAI3D Haptic Framework를 활용하여 손쉽게 햅틱 피드백을 구현할 수 있게 합니다.\n' +
        '개발자를 위한 Unity Asset은 API형태로 제작하여 해당 기능을 쉽게 사용할 수 있도록 하였습니다.\n' +
        '비개발자를 위한 프로그램은 Haptic property를 GUI를 통해 설정할 수 있게 하여 테스트 및 전시에 활용될 수 있는 형태로 구성하고 있습니다.\n' +
        '자세한 설명은 하단의 논문 링크를 참고해 주시길 바랍니다. \n',
    updates: '비접촉식 햅틱스 기반 볼륨 데이터 탐색 기법은 홀로그래픽 디스플레이 상에 가시화되고 있는 볼륨 데이터를 사용자의 손을 통해 촉감적으로 탐색할 수 있도록 합니다. \n' +
'제안된 기법은 컨텐츠 제작자가 설정한 관심 영역에 대한 형상을 촉감 패턴으로 생성하여 볼륨의 내부 구조를 파악할 수 있습니다.\n',
    paperlink : 'https://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=5341989',
    demo: "@/assets/sketchscope.png"
}

export {etc}